import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    public loginForm: FormGroup;
    public error: any;
    public submitted = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: FormBuilder,
        private authService: AuthService,
        private snackBar: MatSnackBar,
    ) {
        if (this.authService.authenticated) {
            this.router.navigate(['/app']).then(r => r);
        }
    }

    get f() {
        return this.loginForm.controls;
    }

    public ngOnInit(): void {
        this.loginForm = this.fb.group({
            email: [null, [Validators.required, Validators.email]],
            password: [null, Validators.required]
        });
    }

    public onSubmit(): void {
        this.submitted = true;

        if (this.loginForm.invalid) {
            return;
        }

        this.loginForm.disable();

        this.authService.login(this.loginForm.value).subscribe(
            () => {
                const redirectUrl = this.activatedRoute.snapshot.queryParamMap.get('redirectUrl') || '/signed-in-redirect';

                this.snackBar.open('Signed in successfully.', 'Ok', {duration: 2000});
                this.router.navigateByUrl(redirectUrl).then(r => r);
            },
            (response: HttpErrorResponse) => {
                this.loginForm.enable();
                this.error = response;
                let verify = this.snackBar.open(response?.error?.message, response.status != 403 ? 'Ok' : 'Verify');
                verify.onAction().subscribe(() => {
                    if (response.status == 403) {
                        this.authService.resendVerificationEmail(this.loginForm.controls.email.value).subscribe(
                            () => {
                                this.snackBar.open('New email verification link requested.', 'Ok', { duration: 3000 });
                            },
                            (response: HttpErrorResponse) => {
                                this.snackBar.open(response?.error?.message, 'Ok', { duration: 3000 });
                            }
                        )
                    }
                });
            }
        );
    }
}
